import {Component, Injector, Input} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorLabelConstants} from "../../../../shared/constants/error-label.constants";
import {BasePageComponent} from "../../../../base/components/base-page.component";
import {DraftModel} from "../../../models/draft.model";
import {Subscription} from "rxjs";
import {UsersService} from "../../../../shared/services/users.service";

@Component({
  selector: 'app-edit-draft',
  templateUrl: './edit-draft.component.html',
  styleUrls: ['./edit-draft.component.scss']
})
export class EditDraftComponent extends BasePageComponent {

  @Input() draft: DraftModel;
  formErrors: any = {};
  editDraftForm: FormGroup;
  subscription: Subscription;

  constructor(injector: Injector, private fb: FormBuilder, private usersService: UsersService) {
    super(injector);
  }

  ngOnDestroyForChildren(): void {
    setTimeout(() => {
      this.editDraftForm.reset();
      this.editDraftForm.markAsPristine();
      this.editDraftForm.updateValueAndValidity();
    }, 0);
    this.subscription.unsubscribe();
  }

  ngOnInitForChildren(): void {
    this.createForm();
    this.createFormErrors();

    this.subscription = this.editDraftForm?.valueChanges.subscribe((form) => {
      this.notifyActionSimple('formEdited', this.editDraftForm);
    });
  }

  pageName(): string {
    return 'EditDraftComponent';
  }

  createForm() {
    this.editDraftForm = this.editDraftForm ? this.editDraftForm : this.fb.group({});

    this.editDraftForm.addControl('draft', new FormControl(this.draft?.name, [Validators.required]));
    this.editDraftForm.addControl('isPrivate', new FormControl(this.draft?.reserved, [Validators.required]));
    this.editDraftForm.addControl('changeOperator', new FormControl(false, [Validators.required]));

    console.log('edit draft', this.editDraftForm);
  }

  createFormErrors(): void {
    this.formErrors['draft'] = [ErrorLabelConstants.REQUIRED];
    this.formErrors['isPrivate'] = [ErrorLabelConstants.REQUIRED];
  }

  checkSameOperator(draft: DraftModel) {
    if (draft.operator?.identityId && this.usersService.getUser().identityId) {
      if (draft.operator?.identityId !== this.usersService.getUser().identityId) {
        return false;
      }
    }
    if (draft.operator?.uida && this.usersService.getUser().uida) {
      if (draft.operator?.uida !== this.usersService.getUser().uida) {
        return false;
      }
    }
    return true;
  }
}
